import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStaff } from "../../store/slices/staff";
import {
  getClassteacher,
  updateClassteacher,
} from "../../store/slices/classteacher";
import { FiHome, FiChevronRight } from "react-icons/fi";

export default function EditClassTeacher() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  /* ---------- REDUX STATE ---------- */

  const { classsectionList = [], loading } = useSelector(
    (state) => state.classsection || {}
  );

  const { staffList = [] } = useSelector((state) => state.staff || {});
  const { classteacherlist = [] } = useSelector(
    (state) => state.classteacher || {}
  );

  const [formData, setFormData] = useState({
    standardId: "",
    sectionId: "",
    teacherId: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchStandardSection());
    dispatch(getStaff());
  }, [dispatch, id]);

  useEffect(() => {
    if (id) {
      const item = { id };

      dispatch(getClassteacher(item))
        .unwrap()
        .then((res) => {
          const matchedClassTeacher = res?.data?.[0];
          console.log(
            "editClassteacher data from class teacher edit page :",
            matchedClassTeacher
          );
          if (matchedClassTeacher) {
            setFormData({
              standardId: matchedClassTeacher.standardId?._id || "",
              sectionId: matchedClassTeacher.sectionId?._id || "",
              teacherId: matchedClassTeacher.teacherId?._id || "",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error(
            err?.response?.data?.message ||
            err?.message ||
            "Failed to fetch class teacher "
          );
        });
    }
  }, [id, dispatch]);

  const standards = classsectionList.map((item) => item.standardId);

  const sections =
    classsectionList.find(
      (item) => item.standardId?._id === formData.standardId
    )?.sectionId || [];

  const selectedTeacher =
    classteacherlist.find((item) => item._id === id)?.teacherId || null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "standardId" && { sectionId: "", teacherId: "" }),
      ...(name === "sectionId" && { teacherId: "" }),
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  /* ---------- validation ---------- */
  const validate = () => {
    let newErrors = {};

    if (!formData.standardId) newErrors.standardId = "Select standard";
    if (!formData.sectionId) newErrors.sectionId = "Select section";
    // if (!formData.teacherId) newErrors.teacherId = "Select teacher";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------- submit ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      await dispatch(updateClassteacher({ id, ...formData })).unwrap();
      toast.success("Class Teacher updated successfully ");
      navigate("/institute/classteachers");
    } catch (err) {
      toast.error(err || "Failed to update class teacher ");
    }
  };

  return (
    <>

      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />
            <Link to="/institute/classteachers">Class Teacher</Link>

            <FiChevronRight className="separator" />

            <span className="active">Edit Class Teacher</span>
          </div>


        </div>

      </div>


      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* standard */}
            <Col lg={3} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>
                <Form.Select
                  name="standardId"
                  value={formData.standardId}
                  onChange={handleChange}
                >
                  <option value="">Select Standard</option>
                  {standards.map((std) => (
                    <option key={std._id} value={std._id}>
                      {std.name}
                    </option>
                  ))}
                </Form.Select>
                {errors.standardId && (
                  <small className="text-danger">{errors.standardId}</small>
                )}
              </Form.Group>
            </Col>

            {/* section */}
            <Col lg={3} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Section</Form.Label>
                <Form.Select
                  name="sectionId"
                  value={formData.sectionId}
                  onChange={handleChange}
                  disabled={!formData.standardId}
                >
                  <option value="">Select Section</option>
                  {sections.map((sec) => (
                    <option key={sec._id} value={sec._id}>
                      {sec.name}
                    </option>
                  ))}
                </Form.Select>
                {errors.sectionId && (
                  <small className="text-danger">{errors.sectionId}</small>
                )}
              </Form.Group>
            </Col>

            {/* teacher*/}
            <Col lg={3} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Teacher</Form.Label>

                <Form.Select
                  name="teacherId"
                  value={formData.teacherId}
                  onChange={handleChange}
                  disabled
                >
                  <option value="">
                    {selectedTeacher ? selectedTeacher.name : "Teacher"}
                  </option>

                  {selectedTeacher && (
                    <option value={selectedTeacher._id}>
                      {selectedTeacher.name}
                    </option>
                  )}
                </Form.Select>

                {errors.teacherId && (
                  <small className="text-danger">{errors.teacherId}</small>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="cta-actions mt-5">
            <button

              className="btn-cancel"
              onClick={() => navigate("/institute/classteachers")}
              style={{ color: "black" }}
            >
              Cancel
            </button>

            <button type="submit" className="btn-submit" disabled={loading}>
              Update
            </button>
          </div>
        </Form>

      </div >
    </>
  );
}
